import React from 'react'
import clsx from 'clsx'
import type { SessionStatus } from '../../types/session.types'
import styles from './SessionStatusBadge.module.css'

export interface SessionStatusBadgeProps {
  status: SessionStatus
  className?: string
}

const STATUS_CONFIG: Record<SessionStatus, { label: string; className: string }> = {
  draft:       { label: 'DRAFT',     className: styles.draft },
  ready:       { label: 'READY',     className: styles.ready },
  in_progress: { label: 'LIVE',      className: styles.in_progress },
  paused:      { label: 'PAUSED',    className: styles.paused },
  completed:   { label: 'COMPLETED', className: styles.completed },
  failed:      { label: 'FAILED',    className: styles.failed },
  cancelled:   { label: 'CANCELLED', className: styles.cancelled },
}

export function SessionStatusBadge({ status, className }: SessionStatusBadgeProps) {
  const s = status || ('draft' as SessionStatus)
  const config = STATUS_CONFIG[s] ?? { label: (s || '').toUpperCase(), className: styles.draft }

  return (
    <span
      className={clsx(styles.badge, config.className, className)}
      data-status={status}
    >
      {config.label}
    </span>
  )
}
